<!-- Translated: yes -->
<template>
  <div class="wrapper" :style="(inline ? 'width:auto; display:inline-block;' : '')">
    <button v-ripple :disabled="count <= min" :class="{round: true}" @click="subtract"><icon name="Minus" :scale="1.5"></icon></button>
    <span class="counter"><strong>{{ count }}</strong>{{ suffix }}</span>
    <button v-ripple :disabled="count >= max" :class="{round: true}" @click="add"><icon name="Plus" :scale="1.5"></icon></button>
  </div>

</template>

<script>
export default {
  props: {
    default: {
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 99,
    },
    suffix: {
      type: String,
      default: '+',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    count: {},
  },
  data() {
    return {
    };
  },
  computed: {
    getCount() {
      return this.count;
    },
  },
  methods: {
    add() {
      if (this.count < this.max) {
        this.count += 1;
        this.$emit('changedCount', this.count);
      }
    },
    subtract() {
      if (this.count > this.min) {
        this.count -= 1;
        this.$emit('changedCount', this.count);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'
.label
  font-family Interstate
  font-size 11px
  font-weight bold
  letter-spacing 0.3px
  color #1c1c1c
  text-transform uppercase
  margin-bottom space-1

.counter
  min-width 1em
  text-align center
  display inline-block
  margin-left 0.5em
  margin-right 0.5em
  font-size 14px
  min-width 25px

.wrapper
  width 100%
  text-align center

.round
  width 35px
  height 35px
  // background-color deep-sea-blue
  // border solid 0.3px deep-sea-blue
  border-radius 100%
  transition-bt()
  &[disabled]
    filter: grayscale(50%)
    opacity 0.37
    &:hover
      background-color: #fff
      border 1px solid rgba(0, 85, 128, 0.6)

.small
  .round
    width 28px
    height 28px
.round
  button-reset()
  display: inline-block
  background white
  border 1px solid rgba(0, 85, 128, 0.6)
  color deep-blue
  text-transform uppercase
  vertical-align middle
  line-height 1em
  font-weight bold
  font-size 11px
  transition all .2s ease
  transition-bt()
  .svg-icon
    position relative
    top 2px
  &:hover
    border-color alpha(deep-blue, .5)
    background-color alpha(deep-blue, .1)
    border-width: 1px
  &:focus
    outline 1px solid rgba(0, 85, 128, 0.1)
    border-color deep-blue
    outline-shadow(deep-blue)

</style>



// WEBPACK FOOTER //
// CounterButton.vue?7908bff6